<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <TituloPagina :titulo="titulo" />
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                flat
                                solo
                                prepend-icon="search"
                                placeholder="Filtro"
                                v-model="search"
                                hide-details
                            ></v-text-field>
                            <DespesasSyncModal :reloadGrid="getRelatorios" v-if="isOnline && hasUnsyncData" />
                            <RelatoriosModal :reloadGrid="getRelatorios" v-if="isOnline && isAdmin" />
                        </v-toolbar>
                        <v-divider></v-divider>

                        <!-- Data table -->
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="relatoriosHeaders"
                                :search="search"
                                :items="relatorios.items"
                                :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
                                :loading="loading"
                                :no-data-text="semDados"
                                class="elevation-1"
                                item-key="name"
                            >
                                <template slot="items" slot-scope="props">
                                    <tr class="clickable" @click="goTo(`/despesas/${props.item._id}`)">
                                        <td class="text-xs-center" v-if="isAdmin">
                                            {{ props.item.projeto_id }}
                                        </td>
                                        <td sm3 class="text-xs-left">
                                            {{ props.item.projeto }}
                                        </td>
                                        <td sm3 class="text-xs-left" v-if="isAdmin">
                                            {{ props.item.usuario.nome /*funcionario*/ }}
                                        </td>
                                        <td sm2 class="text-xs-right">
                                            {{ props.item.saldo | currency }}
                                        </td>
                                        <td sm2 class="text-xs-center">
                                            {{ formatDate(props.item.dt_fechamento) | placeholder('-') }}
                                        </td>
                                        <td sm2 class="text-xs-center">
                                            <v-chip
                                                small
                                                :color="getColorByStatus(props.item.status)"
                                                text-color="white"
                                            >{{ props.item.status }}</v-chip>
                                        </td>
                                        <td class="no-wrap text-xs-right" v-if="isAdmin">
                                            <RelatoriosModal :reloadGrid="getRelatorios" :id="props.item._id" :relatorio="props.item" v-if="canEditRelatorio(props.item.status)" />
                                            <ExcluirModal :reloadGrid="getRelatorios" :id="props.item._id" :route="route" v-if="canEditRelatorio(props.item.status)" />
                                        </td>
                                        <td class="no-wrap text-xs-right" v-else>
                                            <DespesasModal
                                                :reloadGrid="getRelatorios"
                                                :tableAction="true"
                                                :relatorio="props.item._id"
                                                v-if="canInsertDespesa(props.item.status)"
                                            />
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import PouchDB           from 'pouchdb-browser';
    import { mapState }      from 'vuex';
    import TituloPagina      from '@/components/crud/TituloPagina';
    import ExcluirModal      from '@/components/crud/ExcluirModal';
    import DespesasModal     from '@/views/despesas/DespesasModal';
    import momentMixin       from '@/mixins/momentMixin';
    import RelatoriosModal   from './RelatoriosModal';
    import DespesasSyncModal from './DespesasSyncModal';

    let despesasDB = new PouchDB('despesas');

    export default {
        name       : 'RelatoriosAdmin',
        mixins     : [momentMixin],
        components : {
            TituloPagina,
            ExcluirModal,
            DespesasModal,
            RelatoriosModal,
            DespesasSyncModal
        },
        methods    : {
            getHasUnsyncData() {
                despesasDB.allDocs({include_docs: true, descending: true}, function(err, doc) {
                    if (err) {
                        console.error('erro [allDocs()]', err);
                    }
                }).then(despesasOff => {
                    this.hasUnsyncData = !(despesasOff.total_rows === 0);
                });
            },
            getRelatorios() {
                this.loading = true;
                this.getHasUnsyncData();
                if (this.isOnline) {
                    const filter = this.isAdmin ? '' : `?filter={"usuario":"${this.user.key}"}`;
                    this.$axios.get(`${this.route}${filter}`).then(response => {
                        this.relatorios.items = response.data.items;
                        this.$offlineStorage.set('relatorios', response.data.items);
                    }).then(() => {
                        this.loading = false;
                    });
                } else {
                    this.relatorios.items = this.$offlineStorage.get('relatorios');
                    this.loading = false;
                }
            },
            getColorByStatus(status) {
                return this.colors[status];
            },
            canInsertDespesa(status) {
                return status == 'Aberto';
            },
            canEditRelatorio(status) {
                return this.isOnline && status !== 'Finalizado';
            },
            goTo(url) {
                this.$router.push({ path : url });
            }
        },
        computed   : {
            ...mapState(['user']),
            isAdmin() {
                return this.user.perfis.some(perfil => perfil === 'Administrador');
            },
            titulo() {
                return this.isAdmin ? 'Relatórios' : 'Projetos';
            },
            semDados() {
                return this.loading ? 'Buscando informações...' : 'Nenhum relatório cadastrado';
            },
            relatoriosHeaders() {
                let headers = [];

                if (this.isAdmin) { //if user.perfis == 'Administrador'
                    headers.push({
                        text  : 'Prj # ',
                        align : 'center',
                        value : 'projeto_id'
                    });
                }
                headers.push({
                    text  : 'Projeto ',
                    align : 'center',
                    value : 'projeto'
                });
                if (this.isAdmin) { //if user.perfis == 'Administrador'
                    headers.push({
                        text  : 'Funcionário ',
                        align : 'center',
                        value : 'usuario.nome' //'funcionario'
                    });
                }
                headers.push({
                    text  : 'Saldo ',
                    align : 'center',
                    value : 'saldo'
                });
                headers.push({
                    text  : 'Data de Fechamento ',
                    align : 'center',
                    value : 'dt_fechamento'
                });
                headers.push({
                    text  : 'Status ',
                    align : 'center',
                    value : 'status'
                });
                headers.push({
                    text  : 'Ações ',
                    align : 'center',
                    width : 1,
                    value : ''
                });

                return headers;
            }
        },
        data() {
            return {
                loading       : true,
                hasUnsyncData : false,
                search        : '',
                route         : 'relatorios',
                relatorios    : {
                    items     : []
                },
                colors        : {
                    Fechado   : 'success',
                    Cancelado : 'error',
                    Aberto    : 'warning'
                }
            };
        },
        mounted() {
            this.getRelatorios();
        }
    };
</script>

<style>
    .clickable { cursor: pointer; }
</style>
